
<!-- 智能电力//成本目标  -->
<template>
  <div class="box">
    <Title
      :text="maintain.CostTarget.Title[0]"
      :engText="maintain.CostTarget.Title[1]"
    ></Title>
    <div class="content">
      <div class="top">
        <div class="left">
          <div class="bgd1"></div>
          <div class="bgd2"></div>
          <!-- <div class="echarts-content">
            <chart-block ref="echart1"></chart-block>
          </div> -->
        </div>
        <div class="right">
          <div>
            <span class="a">实际用能:</span><span class="b">1000</span>kwh
          </div>
          <div>
            <span class="a">目标用能:</span><span class="b">1000</span>kwh
          </div>
        </div>
      </div>
      
      <div class="bottom">
        <div class="left">
          <div class="e">
            <!-- echarts -->
          </div>
          <div>同比</div>
          <div class="shuxingVal">
            <div class="white scale">100%</div>
            <div class="add"></div>
          </div>
        </div>
        <div class="center"></div>
        <div class="right">
          <div class="e">
            <!-- echarts -->
          </div>
          <div>环比</div>
          <div class="shuxingVal">
            <div class="white scale">100%</div>
            <div class="reduce"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import Title from "../../components/title/index.vue";
import { mapState, mapActions } from "pinia"; //引入映射函数
import useStore from "@/store/index"; //引入store
export default {
  components: {
    Title,
  },
  computed: {
    ...mapState(useStore, ["maintain"]),
  },
  mounted() {
    // this.$refs.echart1.setOption(this.maintain.CostTarget.data[0]);
    // this.$refs.echart2.setOption(this.electricity.CostTarget.data[1]);
  },
};
</script>
  
  <style scoped>
.box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.content {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  /* background-color: red; */
}
.content .top {
  flex: 1;
  display: flex;
  /* background: seagreen; */
  width: 100%;
}
.content > div .left,
.content > div .right {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.content .top .left{
  flex: 1;
  position: relative;
}
.bgd1{
  position: absolute;
  width: 100%;
  height: 100%;
  background: url('@/assets/img/b4_1.png') no-repeat;
  background-size: 135px 125px;
  background-position: center center;
  
}
.bgd2{
  position: absolute;
  width: 100%;
  height: 100%;
  background: url('@/assets/img/b4_2.png') no-repeat;
  background-size: 34px 32px;
  background-position: center 30px;
  
  animation-name: identifier;
  animation-duration: .5s;
  animation-timing-function:ease;
  animation-direction: alternate-reverse;  
  animation-iteration-count: infinite;
}
@keyframes identifier {
  from {transform: translateY(0px)}
    to {transform: translateY(18px)}
}
.content .top .right > div {
  width: 155px;
  height: 39px;
  background: url("@/assets/img/border2.png") no-repeat;
  background-size: 100% 100%;
  margin: 7px 0px;
  color: white;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.content .top .right .a {
  color: #b8cbf4;
  font-size: 16px;
}
.content .top .right .b {
  font-size: 16px;
  margin: 0px 2px 0px 5px;
}
.content .bottom {
  height: 66px;
  display: flex;
  font-size: 12px;
  justify-content: space-between;
}
.content .bottom .left
{
  display: flex;
  flex-direction: initial;
  align-items: center;
}
.content .bottom .left .e {
  width: 65px;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: url('@/assets/img/a1.png') no-repeat;
  background-size: 80% 80%;
  background-position: center center;
}
.content .bottom .center{
  width: 1px;
	border-left: 1px dashed #5a6b8b;
}
.content .bottom .right{
  flex-direction: initial;
  align-items: center;

}
.content .bottom .right .e{
  width: 65px;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: url('@/assets/img/a2.png') no-repeat;
  background-size: 80% 80%;
  background-position: center center;
}
.echarts-content{
  margin: 0 !important;
}
.content .bottom .shuxingVal {
  display: flex;
  align-items: center;
  margin-left: 6px;
}
.white {
  color: #fff;
}
</style>